import { Check, PersonAdd } from "@mui/icons-material";
import { KeyDriveSelect } from "../../../../components/KeydriveComponents/Selects/KeyDriveSelect";
import { User } from "../../../../model/OrganizationModel";
import { Box, SelectChangeEvent } from "@mui/material";
import { KeyDriveBodyMin } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { KeyDriveBodyMax } from "../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import PrivilegeCardListing from "./PrivilegeCardListing";
import { useTranslation } from "react-i18next";
import { UserPermission } from "../../../../model/UserModel";
import { GroupPermission } from "../../../../model/GroupModel";
import { KeyDrivePageContainer } from "../../../../components/KeydriveComponents/PageContainer/KeyDrivePageContainer";
import { KeyDrivePrimaryButton } from "../../../../components/KeydriveComponents/Buttons/KeyDrivePrimaryButton";
import { PermissionTargetType } from "../../../../enums/PermissionTargetType";

interface IPrivilegesStateAddingUser {
  AddPermission: () => void;
  organizationUsers: User[];
  itemUsers?: UserPermission[];
  itemGroups?: GroupPermission[];
  handleUser(e: SelectChangeEvent): void;
  newUserSearch: string;
  setPermissionType: (set: number) => void;
  isItemPage: boolean;
  targetType: PermissionTargetType;
  permissionType: number;
  backBtn:() => void;
}

function PrivilegesStateAddingUser({
  AddPermission,
  organizationUsers,
  handleUser,
  newUserSearch,
  setPermissionType,
  isItemPage,
  itemUsers,
  itemGroups,
  targetType,
  permissionType,
  backBtn
}: IPrivilegesStateAddingUser) {

  const { t } = useTranslation();

  function KeydriveSelectHandler() {
    if (isItemPage) {
      if (targetType == PermissionTargetType.User) {
        return (
          <KeyDriveSelect<UserPermission>
            renderItem={(item) => (
              <Box display="flex" alignItems="center">
                {item.userName}
                <Box ml="4px">
                  <KeyDriveBodyMin
                    text={`(${item.login})`}
                    color="#2D2D2D"
                    needBold={false}
                    needEllipses={false}
                    opacityParams={{
                      needOpacity: true,
                      opacityLevel: "0.5"
                    }}
                  />
                </Box>
              </Box>
            )}
            keyExtract={(item) => item.userId}
            items={itemUsers!}
            onChange={handleUser}
            value={organizationUsers.some(u => u.id === newUserSearch) ? newUserSearch : ""}
            label={t("AdminConsole.User")}
            needFullWidth
          />
        );
      } else if (targetType == PermissionTargetType.Group) {
        return (
          <KeyDriveSelect<GroupPermission>
            renderItem={(item) => (
              <Box display="flex" alignItems="center">
                {item.groupName}
                <Box ml="4px">
                  <KeyDriveBodyMin
                    text={`(${item.groupName})`}
                    color="#2D2D2D"
                    needBold={false}
                    needEllipses={false}
                    opacityParams={{
                      needOpacity: true,
                      opacityLevel: "0.5"
                    }}
                  />
                </Box>
              </Box>
            )}
            keyExtract={(item) => item.groupId}
            items={itemGroups!}
            onChange={handleUser}
            value={newUserSearch}
            label={t("AdminConsole.User")}
            needFullWidth
          />
        )
      }
    } else {
      return (
        <KeyDriveSelect<User>
          renderItem={(item) => (
            <Box display="flex" alignItems="center">
              {item.name}
              <Box ml="4px">
                <KeyDriveBodyMin
                  text={`(${item.login})`}
                  color="#2D2D2D"
                  needBold={false}
                  needEllipses={false}
                  opacityParams={{
                    needOpacity: true,
                    opacityLevel: "0.5"
                  }}
                />
              </Box>
            </Box>
          )}
          keyExtract={(item) => item.id}
          items={organizationUsers}
          onChange={handleUser}
          value={organizationUsers.some(u => u.id === newUserSearch) ? newUserSearch : ""}
          label={t("AdminConsole.User")}
          needFullWidth
        />
      )
    }
  }

  return (
    <KeyDrivePageContainer
      icon={<PersonAdd fontSize='large' sx={{ color: "#22638D" }} />}
      title={t("Privileges.AddUser")}
      subtitle={""}
      actions={<KeyDrivePrimaryButton
        TextComponent={KeyDriveBodyMin}
        TextComponentProps={{
          color: "",
          needBold: false,
          needEllipses: false,
          text: t("Privileges.Add")!
        }}
        startIcon={<Check />}
        onClick={AddPermission}
      />}
      onClickBtnBack={(e)=> backBtn()}>
      {KeydriveSelectHandler()}
      <Box
        marginTop="30px"
        marginBottom="15px"
      >
        <KeyDriveBodyMax
          color="#2D2D2D"
          needBold
          needEllipses={false}
          text={t("Privileges.Privileges")}
        />
        <KeyDriveBodyMin
          color="#2d2d2d"
          needBold={false}
          needEllipses={false}
          text={t("Privileges.DefineWithOptions")}
        />
      </Box>
      <PrivilegeCardListing
        setPermissionType={setPermissionType}
        permissionType={permissionType}
        isItemPrivilege={isItemPage}
      />
    </KeyDrivePageContainer>
  );
}

export default PrivilegesStateAddingUser;